import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { useGetPeriodOptions } from 'components/BusinessToolForm/constants/periods';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { ILiquidityFormHeaderProps } from './types';

import styles from './LiquidityFormHeader.module.scss';

export const LiquidityFormHeader: React.FC<ILiquidityFormHeaderProps> = ({ disabled = false }) => {
  const { control } = useFormContext();
  const periodOptions = useGetPeriodOptions();

  return (
    <Box className={styles.header}>
      <RadioControlled
        id="liquidityFormHeader.period"
        name={GLOBAL_PERIOD_NAME}
        control={control}
        options={periodOptions}
        disabled={disabled}
      />
    </Box>
  );
};
